import React from 'react';
import PropTypes from 'prop-types';
import MuiCheckbox from '@material-ui/core/Checkbox';
import cn from 'classnames';
import styles from './Checkbox.module.css';

// Formik-field checkbox built on MUI (no react-bootstrap), styled to the
// "Design Foundation" checkbox spec. Renders ONLY the checkbox control — the
// label and error message are owned by the consuming component. Custom box
// icons render the rounded square in every state; `size` switches between
// sm (16px) and md (20px).

const CheckGlyph = () => (
    <svg className={styles.glyph} viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path
            d="M3.5 8.5L6.5 11.5L12.5 5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const MinusGlyph = () => (
    <svg className={styles.glyph} viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M3.5 8H12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

// `size` (xs | sm | md) and `variant` (checked | unchecked | disabled*) each map
// directly to a CSS class of the same name.
const box = (size, variant) => cn(styles.box, styles[size], styles[variant]);

const Checkbox = ({ field, form, className, size = 'sm', disabled, custom, ...props }) => {
    return (
        <MuiCheckbox
            id={field.name}
            name={field.name}
            checked={!!field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            disabled={disabled}
            color="default"
            disableRipple
            classes={{ root: cn(styles.root, className) }}
            icon={<span className={box(size, disabled ? 'disabledUnchecked' : 'unchecked')} />}
            checkedIcon={
                <span className={box(size, disabled ? 'disabledChecked' : 'checked')}>
                    <CheckGlyph />
                </span>
            }
            indeterminateIcon={
                <span className={box(size, disabled ? 'disabledChecked' : 'checked')}>
                    <MinusGlyph />
                </span>
            }
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    form.setFieldValue(field.name, !field.value);
                }
            }}
            {...props}
        />
    );
};

Checkbox.propTypes = {
    field: PropTypes.object,
    form: PropTypes.object,
    className: PropTypes.string,
    size: PropTypes.oneOf(['xs', 'sm', 'md']),
    disabled: PropTypes.bool,
    custom: PropTypes.bool,
};

export default Checkbox;
